import React from "react";
import Reveal from "@/components/Reveal";
import { useSite } from "@/context/SiteContext";
import { IMAGES } from "@/lib/images";
import DiamondMark from "@/components/DiamondMark";

export default function About() {
  const { settings } = useSite();
  const values = settings.values || [
    "Integrity", "Excellence", "Innovation", "Customer First", "Accountability", "Sustainability", "Continuous Improvement",
  ];

  return (
    <div data-testid="page-about" className="bg-bd-ivory min-h-screen">
      <section className="pt-40 pb-16 bg-bd-black grain relative">
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">About the Group</p>
            <h1 className="font-serif text-4xl md:text-7xl text-bd-ivory leading-[1.05] max-w-4xl">
              A diversified group built for the long term
            </h1>
          </Reveal>
        </div>
      </section>

      {/* Founder */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={IMAGES.founder} alt="Christina Handley, Founder & CEO" className="w-full h-full object-cover" />
                <div className="absolute inset-0 border border-black/10" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="overline text-bd-gold mb-5">Founder & CEO</p>
              <h2 className="font-serif text-4xl md:text-5xl text-bd-black mb-6">Christina Handley</h2>
              <p className="text-base md:text-lg text-black/65 leading-relaxed max-w-2xl whitespace-pre-line">
                {settings.about_founder}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28 bg-bd-black grain relative">
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="overline text-bd-gold mb-6">Our Values</p>
            <h2 className="font-serif text-3xl md:text-5xl text-bd-ivory max-w-2xl leading-tight mb-14">
              The principles behind every venture
            </h2>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {values.map((v, i) => (
              <Reveal key={v} delay={(i % 4) * 0.05}>
                <div className="bg-bd-black p-8 h-full min-h-[150px] flex flex-col justify-between">
                  <span className="font-serif text-3xl text-bd-gold/30">0{i + 1}</span>
                  <h3 className="font-serif text-xl text-bd-ivory mt-6">{v}</h3>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Legacy */}
      <section className="py-24 md:py-32 bg-bd-ivory">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <Reveal>
            <DiamondMark size={44} className="mx-auto mb-8" />
            <p className="overline text-bd-gold mb-6">Legacy</p>
            <h2 className="font-serif text-3xl md:text-5xl text-bd-black leading-tight mb-8">
              Long-term value creation
            </h2>
            <p className="text-base md:text-lg text-black/65 leading-relaxed whitespace-pre-line">
              {settings.about_legacy}
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
